//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../common-components/file-uploader';
import {formatDate} from '../../../lib/date';

export default {
    name: 'activity-signUp',
    components: {
        fileUploader
    },
    props: {
        activityInfo: {
            type: Object,
            required: true
        }
    },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            activity: {
                signUpSetting: {
                    memberStr: '',
                    cityName: '',
                    projectName: '',
                    stagesName: ''
                }
            },
            checkAllGroup: [],
            coupons: []
        };
    },
    methods: {
        getEventCouponList() {
            if (!this.activity || !this.activity.id) {
                return;
            }
            abp.ajax.get('/api/services/app/EventCoupon/GetEventCouponList?eventId=' + this.activity.id + '&businessType=Activity').then(res => {
                this.coupons = [];
                this.coupons.push(...res.data.result);
            }).finally(() => {
                this.saving = false;
            });
        }
    },
    created() {
        this.activity = this.activityInfo;
        this.getEventCouponList();
        // if (this.activity.signUpSetting.memberStr != null && this.activity.signUpSetting.memberStr != '' && this.activity.signUpSetting.memberStr != undefined) {
        //     this.checkAllGroup = this.activity.signUpSetting.memberStr.split(',');
        // }
    },
    watch: {
        activityInfo() {
            this.activity = this.activityInfo;
            this.getEventCouponList();
            // if (this.activity.signUpSetting.memberStr != null && this.activity.signUpSetting.memberStr != '') {
            //     this.checkAllGroup = this.activity.signUpSetting.memberStr.split(',');
            // }

        }
    }
};
